const EndpointCodeSection = ({ code, setCode, onResetTemplate, onSave, saving }) => (
  <div>
    <div className="section-header" style={{ marginBottom: "8px" }}>
      <button className="button secondary" onClick={onResetTemplate} type="button">
        Reset template
      </button>
      <button className="button" onClick={onSave} type="button" disabled={saving}>
        {saving ? "Saving..." : "Save"}
      </button>
    </div>
    <textarea value={code} onChange={(e) => setCode(e.target.value)} rows={14} className="code-block" />
  </div>
);

export default EndpointCodeSection;
